import { useEffect, useState } from "react";
import { RefreshCw, WifiOff } from "lucide-react";
import { network } from "../platform";
import { pwa } from "../pwa/sw-register";

export function PwaBanners() {
  const [online, setOnline] = useState(network.isOnline());
  const [update, setUpdate] = useState(pwa.hasUpdate());

  useEffect(() => network.subscribe(setOnline), []);
  useEffect(() => pwa.onUpdate(() => setUpdate(true)), []);

  return (
    <div className="safe-top sticky top-0 z-[60]">
      {!online && (
        <div data-testid="offline-banner" role="alert" className="flex items-center justify-center gap-2 bg-slate-900 px-4 py-2 text-sm text-white">
          <WifiOff size={16} /> You are offline. Requests cannot be sent. In an emergency, call <a href="tel:911" className="font-bold underline">911</a>
        </div>
      )}
      {update && (
        <div data-testid="update-banner" className="flex items-center justify-center gap-3 bg-[#FBBF2E] px-4 py-2 text-sm text-slate-900">
          A new version of FASTPASS is available.
          <button data-testid="update-apply-button" onClick={() => pwa.applyUpdate()} className="inline-flex items-center gap-1 rounded-lg bg-slate-900 px-3 py-1 font-semibold text-white">
            <RefreshCw size={14} /> Update
          </button>
        </div>
      )}
    </div>
  );
}
